// Proben-Auswahl (Sachets) im Cart-Drawer — Markup: snippets/cdx-cart-sachets.liquid
if (!customElements.get('cdx-cart-sachets')) {
  class CdxCartSachets extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);

      // Theme-seitige Regeln: unerlaubte Sachets entfernen / Menge auf 1 setzen
      let fix = {};
      try {
        fix = this.dataset.fix ? JSON.parse(this.dataset.fix) : {};
      } catch (e) {
        fix = {};
      }
      if (Object.keys(fix).length) {
        this.request(window.routes?.cart_update_url || '/cart/update', { updates: fix });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-sachet-action]');
      if (!button || button.disabled) return;

      if (button.dataset.sachetAction === 'add') {
        this.request(window.routes?.cart_add_url || '/cart/add', {
          items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _sachet: '1' } }],
        });
      } else if (button.dataset.sachetAction === 'remove') {
        this.request(window.routes?.cart_change_url || '/cart/change', { id: button.dataset.lineKey, quantity: 0 });
      }
    };

    async request(url, body) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-loading');
      this.showError('');

      try {
        const response = await fetch(`${url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            ...body,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        const state = await response.json();

        if (!response.ok || state.status) {
          this.showError(state.description || state.message || window.cartStrings?.error || 'Error');
          return;
        }

        const sections = state.sections || {};
        const itemCount = typeof state.item_count === 'number' ? state.item_count : null;
        this.renderSections(sections, itemCount);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cdx-cart-sachets', cartData: state });
        }
      } catch (e) {
        console.error('[cdx-cart-sachets]', e);
        this.showError(window.cartStrings?.error || 'Error');
      } finally {
        this.busy = false;
        this.classList.remove('is-loading');
      }
    }

    renderSections(sections, itemCount) {
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      const drawer = document.querySelector('cart-drawer');

      if (sections['cart-drawer']) {
        const source = parse(sections['cart-drawer']).querySelector('#CartDrawer');
        const target = document.getElementById('CartDrawer');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          if (drawer) {
            target
              .querySelector('#CartDrawer-Overlay')
              ?.addEventListener('click', drawer.close.bind(drawer));
          }
        }
      }

      if (sections['cart-icon-bubble']) {
        const source = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }

      if (drawer) {
        const isEmpty = itemCount === 0;
        if (itemCount !== null) drawer.classList.toggle('is-empty', isEmpty);
        else drawer.classList.remove('is-empty');
      }
    }

    showError(message) {
      const el = this.querySelector('.cdx-sachets__error');
      if (!el) return;
      el.textContent = message;
      el.hidden = !message;
    }
  }

  customElements.define('cdx-cart-sachets', CdxCartSachets);
}
